<template>
    <div class="content_list">
      <div class="menuList" id="menuList">
        <div
          class="menuName"
          @click="selectMenu(i)"
          v-for="(i) in menuList"
          :key="i.index"
          :class="{isActive: activeIndex == i.index}"
        >{{i.name}}<img class="menuImg" v-if="i.showImg" src="../../assets/img/hot.png"></div>
      </div>
  </div>
</template>
<script>
import casousel from "./Carousel";
export default {
  components: { casousel },
  data() {
    return {
      activeIndex: 0,
      menuList: [
        { name: "首页", index: "0",path: '/' },
        { name: "云现场", index: "1",path: '/cloudScene' },
        { name: "材料检测", index: "2", path: '/materialTest', showImg: true },
        { name: "高端测试", index: "3", path: '/highTest', showImg: true },
        { name: "生物检测", index: "12",path: '/bioDetection', showImg: true },
        { name: "仪器采购", index: "11", path: '/equipmentMall', showImg: true },
        { name: "材料加工", index: "4", path: '/materialProcessing' },
        { name: "试剂耗材", index: "5", path: '/lifeSciences' },
        { name: "环境检测", index: "6", path: '/environmentDetection' },
        { name: "模拟计算", index: "7", path: '/analogComputation' },
        { name: "科研绘图", index: "8", path: '/scientificDraw' },
        { name: "论文润色", index: "9", path: '/thesisServices' },
        { name: "数据分析", index: "10", path: '/dataAnalysis' },
        { name: "关于我们", index: "13",path: '/aboutUsList' }
      ]
    };
  },
  created() {
    this.activeIndex = this.$route.query.type ? this.$route.query.type : 0;
    window.onscroll = function() {
      //为了保证兼容性，这里取两个值，哪个有值取哪一个
      //scrollTop就是触发滚轮事件时滚轮的高度
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let element = document.querySelector('.content_list');
      if(scrollTop > 120){
        element.classList.add('sticky');
      }else{
        element.classList.remove('sticky');
      }
    }
  },
  watch: {
    $route: {
      deep: true, // 深度监听
      handler() {
        this.activeIndex = this.$route.query.type ? this.$route.query.type : 0;
      }
    }
  },
  methods: {
    selectMenu(i) {
      this.activeIndex = i.index;
      if(i.index == 5) {
        window.open('https://mall.navi-sci.cn/', '_blank')
      }
      this.$router.push({ path: i.path, query: { type: i.index == 0 ? undefined : i.index } })
    }
  }
};
</script>
<style scoped>
.menuImg {
  width: 30%;
  position: absolute;
  top: 7px;
  right: 1px;
}
.content_list {
  width: 100%;
  display: flex;
  background: #fff;
  justify-content: center;
}
.menuList {
  width: 80%;
  display: flex;
  flex-flow: row nowrap;
}
.menuName {
  position: relative;
  width: 25%;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  border-top: 3px solid #fff;
}
.sticky{
  position: fixed;
  top: 0;
  z-index: 5;
  padding-top: 20px;
  animation:myfirst .8s;
}
@keyframes myfirst
{
	0%   {padding-top: 0px;}
	100% {padding-top: 20px;}
}
@media only screen and (max-width: 1440px) {
  .menuName {
    font-size: 16px;
    height: 50px;
    line-height: 50px;
  }
}
@media only screen and (max-width: 1200px) {
  .menuName {
    font-size: 13px;
    height: 40px;
    line-height: 40px;
  }
}
.isActive {
  color: #4d6fff;
  border-top: 3px solid #4d6fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>